import { render, staticRenderFns } from "./tags_group.vue?vue&type=template&id=b9f791e8&scoped=true"
import script from "./tags_group.vue?vue&type=script&lang=ts"
export * from "./tags_group.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f791e8",
  null
  
)

export default component.exports